import { render, staticRenderFns } from "./FooterGreen.vue?vue&type=template&id=9a11685a&scoped=true&"
import script from "./FooterGreen.vue?vue&type=script&lang=js&"
export * from "./FooterGreen.vue?vue&type=script&lang=js&"
import style0 from "./FooterGreen.vue?vue&type=style&index=0&id=9a11685a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a11685a",
  null
  
)

component.options.__file = "FooterGreen.vue"
export default component.exports